/**
 * binary units, because file sizes and quota arrive as bytes and the storage
 * counts in powers of 1024
 */
const BYTE_UNITS = ['B', 'KB', 'MB', 'GB', 'TB'];

/**
 * formatBytes
 * @param bytes
 * @param locale
 */
export function formatBytes(bytes: number, locale: string = 'de'): string {
  if (!Number.isFinite(bytes) || bytes <= 0) {
    return '0 B';
  }

  let exponent = Math.min(
      Math.floor(Math.log(bytes) / Math.log(1024)),
      BYTE_UNITS.length - 1
    ),
    value = bytes / Math.pow(1024, exponent),
    /**
     * bytes and kilobytes gain nothing from decimals, larger units read
     * better with one
     */
    digits = exponent < 2 ? 0 : 1;

  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  }).format(value) + ' ' + BYTE_UNITS[exponent];
}

/**
 * formatTimestamp
 * the storage reports modification times as unix seconds, not as iso strings
 * @param unixSeconds
 * @param locale
 */
export function formatTimestamp(unixSeconds: number, locale: string = 'de'): string {
  if (!Number.isFinite(unixSeconds) || unixSeconds <= 0) {
    return '';
  }

  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(unixSeconds * 1000));
}
